import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { finalize } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { CompanyApiService } from './company-api.service';
import { CurrentUserService } from './current-user.service';
import { DevAuthService } from './dev-auth.service';

const DEFAULT_LOGOUT_ROUTE = '/login';

/** Centralizes the full sign-out flow so it can be triggered from anywhere (nav bar, forced re-login after a credential change, etc). */
@Injectable({ providedIn: 'root' })
export class SessionService {
  private readonly authService = inject(AuthService);
  private readonly companyApi = inject(CompanyApiService);
  private readonly currentUser = inject(CurrentUserService);
  private readonly devAuth = inject(DevAuthService);
  private readonly router = inject(Router);

  signOut(logoutRoute = DEFAULT_LOGOUT_ROUTE): void {
    const userId = Number(this.currentUser.userId());
    const sessionId = this.authService.getSessionId();

    if (sessionId && userId) {
      this.companyApi
        .signOutUser({ userId, sessionId })
        .pipe(finalize(() => this.completeSignOut(logoutRoute)))
        .subscribe();
    } else {
      this.completeSignOut(logoutRoute);
    }
  }

  private completeSignOut(logoutRoute: string): void {
    this.authService.broadcastLogout();
    this.devAuth.logout();
    this.router.navigate([logoutRoute]);
  }
}
